import { useParams } from 'react-router';
import { ProductView } from '../../components/ProdutosPanel';

export function ProdutoPage() {
  const { id = '' } = useParams();
  return <ProductView key={id} id={id} />;
}
